export const notEqualSign = String.fromCharCode(8800);
